import { useState, useEffect } from 'react'
import { useContainerClick } from 'context/dash/ContainerClick'
import productsApi from 'api/requests/products'
import Paginate from 'components/_UI/Paginate'
import Loader from 'components/_UI/Loader'
import { ProductCardsContainer } from './products.styled'
import { ContentProductCard } from './products.styled'
import ProductCard from './ProductCard'
import NotResultDashBoard from 'components/commons/NotResultDashBoard'

export default function ModelProductsList({
    onProductClick = () => {},
    onDropdownAction = () => {},
    createProduct = () => {},
    refreshKey,
}) {
    const { containerClick } = useContainerClick()
    const [loading, setLoading] = useState(true);
    const [products, setProducts] = useState([])
    const [selected, setSelected] = useState(false)
    const [lastPage, setLastPage] = useState(null)
    const [perPage, setPerpage] = useState(null)
    const [currentPage, setCurrentPage] = useState(null)
    const [totalItems, setTotalItems] = useState(null)

    function onPaginate(page) {
        getProducts(page)
    }

    async function getProducts(number = 1) {
        setLoading(true);
        try {
            const { data } = await productsApi.get({ page: number });
            setProducts(data?.data)
            setLastPage(data?.meta?.last_page)
            setPerpage(data?.meta?.per_page)
            setCurrentPage(data?.meta?.current_page)
            setTotalItems(data?.meta?.total)

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (containerClick) {
            setSelected(false)
        }
    }, [containerClick])

    useEffect(() => {
        getProducts()
    }, [refreshKey])

    return (
        <>
            {loading ? (
                <Loader />
            ) : products.length === 0 ? (
                <NotResultDashBoard
                    text="Sem produtos cadastrados? Cadastre seu primeiro produto e maximize suas vendas durante a compra do ingresso."
                    textButton="Adicionar produto"
                    onClick={createProduct}
                    ilustration="stock"
                />
            ) : (
                <>
                    <ProductCardsContainer>
                        {products.map((product, index) => (
                            <ContentProductCard key={index} onClick={e => e.stopPropagation()}>
                                <ProductCard
                                    data={product}
                                    onMoreClick={() => setSelected(index)}
                                    dropDownVisible={index === selected}
                                    visibleMoreAction
                                    onProductClick={() => {
                                        onProductClick({action: 'edit', ...product});
                                        setSelected(index);
                                    }}
                                    onDropdownAction={e =>
                                        onDropdownAction({ action: e, ...product })
                                    }
                                />
                            </ContentProductCard>
                        ))}
                    </ProductCardsContainer>

                    {lastPage > 1 && (
                        <Paginate
                            perPage={perPage}
                            totalItems={totalItems}
                            lastPage={lastPage}
                            firstPage={1}
                            onPaginate={onPaginate}
                            currentPage={currentPage}
                            marginTop="30px"
                        />
                    )}
                </>
            )}
        </>
    )
}